import { saveToken } from '../../utils/localStore';
import axiosClient from '../axiosClient';

export const getLoginLink = async (redirectUri) => {
    const res = await axiosClient.get('/authen/login-link', {
        params: {
            redirect_uri: redirectUri,
        },
    });
    return res;
};

export const refreshToken = async (refreshToken, redirectUri) => {
    const res = await axiosClient.post('/authen/refresh-token', {
        refreshToken: refreshToken,
        redirectUri: redirectUri,
    });
    saveToken(res);
    return res;
};

export const checkMeService = async (userId) => {
    try {
        const res = await axiosClient.get('/user/checkme', {
            params: {
                id: userId,
            },
        });
        return res;
    } catch (error) {
        throw new Error('Error checking user: ' + error.message);
    }
};

export const loginService = async (data) => {
    const res = await axiosClient.post('/authen/verify', data);
    return res;
};

export const logoutService = async (data) => {
    const res = await axiosClient.post('/authen/logout', data);
    return res;
};

export const changePasswordService = async (id, data) => {
    const res = await axiosClient.patch(`/user/${id}`, data);
};
